import { FormFieldNames } from '@/types';
export const fieldsMapping = {
    default: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        required: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        optional: [],
    },
    social_planner: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        required: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        optional: [],
    },
    blog: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        required: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        optional: [],
    },
    funnel: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        required: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        optional: [],
    },
    website: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        required: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        optional: [],
    },
    email_builder: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        required: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        optional: [],
    },
    media_library: {
        fields: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        required: [
            FormFieldNames.DESCRIPTION,
            FormFieldNames.NUMBER_OF_VARIATIONS,
            FormFieldNames.PRESET,
        ],
        optional: [],
    },
};
